import { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getCroppedImg } from '../../../utils/cropUtils';

const CropImage = ({ handleSave, defaultImg, handleClose }) => {
  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [croppedImageBlob, setCroppedImageBlob] = useState(null);
  const [step, setStep] = useState('crop'); // 'crop' for cropping, 'preview' for preview screen

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const onFileChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      // Check if the file type is in the allowed list
      if (!validImageTypes.includes(file.type)) {
        toast.error('Please upload a valid image file (JPEG, PNG, JPG).');
        return;
      }
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  };

  const handleCrop = async () => {
    try {
      const croppedImageBlob = await getCroppedImg(image, croppedAreaPixels);
      const croppedImageUrl = URL.createObjectURL(croppedImageBlob);
      setCroppedImageBlob(croppedImageBlob);
      setCroppedImage(croppedImageUrl);
      setStep('preview'); // Move to preview step
      toast.success('Image cropped successfully!');
    } catch (error) {
      toast.error('Failed to crop the image.');
    }
  };

  const handleBack = () => {
    setStep('crop'); // Go back to cropping step
    setCroppedImage(null); // Reset cropped image preview
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      {!image ? (
        <div className="dropfile_container">
          <div className="attachment_card">
            <div className="attachment_body">
              <div className="file-upload">
                <input
                  className="file-input"
                  accept="image/*"
                  type="file"
                  multiple
                  onChange={onFileChange}
                />
                <div className="card-subtitle">Drag n Drop your file here</div>
              </div>
            </div>
          </div>
        </div>
      ) : step === 'crop' ? (
        <div>
          <div style={{ position: 'relative', width: '500px', height: 400 }}>
            <Cropper
              image={image}
              crop={crop}
              zoom={zoom}
              aspect={1} // Adjust aspect ratio as needed
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>

          <div className="rightAction spacing_bt" style={{ marginTop: '20px' }}>
            <button
              type="button"
              className="btn btn-outline-primary"
              data-bs-dismiss="modal"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={handleCrop}>
              Next
            </button>
          </div>
        </div>
      ) : (
        <div>
          <h3>Cropped Preview:</h3>
          <img
            src={croppedImage}
            alt="Cropped"
            style={{ maxWidth: '100%', height: '400px', border: '1px solid #ddd' }}
          />
          <div className="rightAction spacing_bt" style={{ marginTop: '20px' }}>
            <button
              type="button"
              className="btn btn-outline-primary"
              data-bs-dismiss="modal"
              onClick={handleBack}
            >
              Back
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleSave(croppedImageBlob)}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CropImage;
